module.exports = __webpack_public_path__ + "gs.21f7c99f17bb19ebe4b9.svg";


//////////////////
// WEBPACK FOOTER
// /var/www/portal/bullseye/node_modules/flag-icon-css/flags/4x3/gs.svg
// module id = ../../../../flag-icon-css/flags/4x3/gs.svg
// module chunks = styles